import React, { useState, useContext } from "react";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import cross6 from "../../../assets/images/cross6.svg";
import ok6 from "../../../assets/images/ok6.svg";
import round6 from "../../../assets/images/round6.svg";
import Button from "@material-ui/core/Button";
// import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { AuthContext } from "../../../context/AuthContext";
import RefreshToken from "../../../components/RefreshToken";

const useStyles = makeStyles((theme) => ({
  rightAlign: {
    textAlign: "right",
  },

  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  backButton: {
    fontSize: "16px",
    textTransform: "capitalize",
    "&:hover": {
      background: "none",
    },
    color: "#19181699",
  },

  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 13,
    },
  },
  imageStyle: {
    borderRadius: "50%",
  },
  imageDivStyle: {
    margin: "30px 0 20px",
  },
  divMarginStyle: {
    marginBottom: "40px",
  },
  divMarginStyle2: {
    marginBottom: "20px",
  },
  fieldWrapper: {
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 15,
    },
  },
  paddingBottomStyle: {
    paddingBottom: "8px",
  },
  linkStyle: {
    textDecoration: "none",
  },
  error: {
    marginBottom: 15,
  },
}));

const PasswordSettings = () => {
  const classes = useStyles();
  // let history = useHistory();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  
  const [messageType, setMessageType] = useState("");
  const [loading, setLoading] = useState(false);

  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const handleClickShowOldPassword = () => {
    setShowOldPassword(!showOldPassword);
  };
  const handleClickShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };
  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let check = newPassword.match(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@[-`{-~]).{6,64}$"
      );
      if (!check) {
        let er = "Please follow the Password requirements";

        enqueueSnackbar(er, {
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
          TransitionComponent: Slide,
        });

        setLoading(false);
        return;
      }

      let token = await RefreshToken(glob_pay_agent_auth, logout, login);
      let data = {
        currentPassword: oldPassword,
        newPassword: newPassword,
        confirmNewPassword: confirmPassword,
      };
      let response = await axios({
        url: "/api/v1/private/password/update",
        method: "put",
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      let er = "Password Changed";
      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
        TransitionComponent: Slide,
      });
    } catch (error) {
      let er = error.response && error.response.data.errors.toString();

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <div className={classes.divMarginStyle}>
        <Typography variant="h5" gutterBottom>
          Change Password
        </Typography>
        <Typography variant="body1">
          Please choose a password that meets the criteria
        </Typography>
      </div>

      <div className={classes.divMarginStyle2}>
        <Grid container alignItems="center">
          <Grid item xs={6}>
            <Typography variant="body1" gutterBottom>
              Old Password
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Link to="/forgot-password" className={classes.linkStyle}>
              <Typography
                variant="body2"
                gutterBottom
                color="primary"
                className={`${classes.rightAlign}`}
              >
                Forgot Password?
              </Typography>
            </Link>
          </Grid>
        </Grid>

        <FormControl
          variant="outlined"
          fullWidth
          size="small"
          className={classes.textField}
        >
          <OutlinedInput
            className={classes.fieldWrapper}
            placeholder="Enter your old password"
            id="outlined-adornment-old-password"
            type={showOldPassword ? "text" : "password"}
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowOldPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showOldPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </div>
      <div className={classes.divMarginStyle2}>
        <Typography variant="body1" gutterBottom>
          New Password
        </Typography>
        <FormControl
          variant="outlined"
          fullWidth
          size="small"
          className={classes.textField}
        >
          <OutlinedInput
            className={classes.fieldWrapper}
            placeholder="Enter new password"
            id="outlined-adornment-new-password"
            type={showNewPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowNewPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showNewPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </div>
      <div className={classes.divMarginStyle2}>
        <Typography variant="body1" gutterBottom>
          Confirm Password
        </Typography>
        <FormControl
          variant="outlined"
          fullWidth
          size="small"
          className={classes.textField}
        >
          <OutlinedInput
            className={classes.fieldWrapper}
            placeholder="Re enter new password"
            id="outlined-adornment-confirm-password"
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowConfirmPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </div>
      {loading ? <LinearProgress /> : null}
      <div className={classes.divMarginStyle2}>
        <Typography variant="body1" className={classes.paddingBottomStyle}>
          Password requirements
        </Typography>

        <Grid
          container
          alignItems="center"
          className={classes.paddingBottomStyle}
        >
          <Grid>
            <img
              src={ok6}
              alt=""
              height="11px"
              style={{ marginRight: "10px" }}
            />
          </Grid>
          <Grid>
            <Typography variant="body2">Must contain characters</Typography>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          className={classes.paddingBottomStyle}
        >
          <Grid>
            <img
              src={ok6}
              alt=""
              height="11px"
              style={{ marginRight: "10px" }}
            />
          </Grid>
          <Grid>
            <Typography variant="body2">
              Must have at least one uppercase letter
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          className={classes.paddingBottomStyle}
        >
          <Grid>
            <img
              src={cross6}
              alt=""
              height="11px"
              style={{ marginRight: "10px" }}
            />
          </Grid>
          <Grid>
            <Typography variant="body2">
              Must have one symbol (#, @, . , $)
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          className={classes.paddingBottomStyle}
        >
          <Grid>
            <img
              src={round6}
              alt=""
              height="11px"
              style={{ marginRight: "10px" }}
            />
          </Grid>
          <Grid>
            <Typography variant="body2">
              Must have one digit (0, 1, . , 9)
            </Typography>
          </Grid>
        </Grid>
      </div>
      <div className={classes.rightAlign}>
        <Button
          className={`${classes.backButton} ${classes.marginRightStyle}`}
          disableRipple={true}
          onClick={() => window.history.back()}
          style={{ fontWeight: 600, padding: "10px 32px" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.buttonStyle}
          onClick={handleSubmit}
          disabled={loading}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default PasswordSettings;
